/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Template_Color_GreyInputs */



/**
* | output |
* | --- |
* | "Grey" |
*
* @param {Settings_Template_Color_GreyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_template_color_grey = /** @type {((inputs?: Settings_Template_Color_GreyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Template_Color_GreyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Grijs")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Gris")
	return /** @type {LocalizedString} */ ("Grey")
});